﻿/**
 * Theme.ts
 *
 * Module for the UI Theme
 */

import * as Constants from "./Constants";

let defaultPrimaryColour = "#0167B0";
let defaultSecondaryColour = "#194789";

/**
 * Init
 * @param {string} primaryColour Primary Colour
 * @param {string} secondaryColour Secondary Colour
 */
export function initialize(primaryColour: string = undefined, secondaryColour: string = undefined) {
	if (!primaryColour) {
		primaryColour = defaultPrimaryColour;
	}

	if (!secondaryColour) {
		secondaryColour = defaultSecondaryColour;
	}

	let sheet = document.createElement("style");

	sheet.textContent =
		`.${Constants.Classes.OverallAnchor}:hover { background-color: ${secondaryColour} } ` +
		`.${Constants.Classes.OverallAnchorActive} { background-color: ${primaryColour} } ` +
		`.${Constants.Classes.SpinnerCircle} { background-color: ${primaryColour} } ` +
		// tslint:disable-next-line:max-line-length
		`.${Constants.Classes.ChoiceGroup} input[type=radio]:checked+label>.${Constants.Classes.ChoiceGroupIcon} { border-color: ${primaryColour} } ` +
		// tslint:disable-next-line:max-line-length
		`.${Constants.Classes.ChoiceGroup} input[type=radio]:hover+label>.${Constants.Classes.ChoiceGroupIcon} { border-color: ${secondaryColour} } ` +
		// tslint:disable-next-line:max-line-length
		`.${Constants.Classes.ChoiceGroup} input[type=radio]:checked+label>.${Constants.Classes.ChoiceGroupIcon}>span { background-color: ${primaryColour} } ` +
		`.${Constants.Classes.SubmitButton} { background-color: ${primaryColour} } ` +
		`.${Constants.Classes.SubmitButton}:hover { background-color: ${secondaryColour} } ` +
		`.${Constants.Classes.Link} { color: ${primaryColour} } ` +
		`.${Constants.Classes.Link}:hover { color: ${secondaryColour} } ` +
		`#${Constants.IDs.TPromptTitle} { color: ${primaryColour} } ` +
		`#${Constants.IDs.TFormTitle} { color: ${primaryColour} } `;

	document.body.appendChild(sheet);
}
